import React, { PropsWithChildren, useRef, useState } from 'react';
//import DataGrid, { Button, Column, Editing, Form, Lookup, MasterDetail, ValidationRule, RequiredRule, GroupPanel } from "devextreme-react/data-grid";
import DataGrid, { Selection, Toolbar, Item, Button, Editing, Form, Grouping, GroupPanel, HeaderFilter, IDataGridOptions, Pager, Paging, Scrolling, SearchPanel } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';

import { Label, GroupItem, SimpleItem, Tab, TabbedItem, TabPanelOptions } from 'devextreme-react/form';
import LicenceDataSource, { downLoadBlobByUrl, downLoadByUrl, getSmartFetchData, UpLoadByUrl } from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import { useFilteredCorporations, useFilteredDealers } from '../hooks/useFilteredDatasource';
import LicenceFormat from '../formats/LicenceFormat';
import CommonLicenceDataGrid from './CommonLicenceDataGrid';
import { useNavigate } from 'react-router-dom';
import DataSource from 'devextreme/data/data_source';
import Guid from "devextreme/core/guid";
import GroupNameSimpleItem from './GroupNameSimpleItem';
import FileUploader from 'devextreme-react/file-uploader';
import { isMobileDevice } from "../utils/DeviceDetect";
import notify from "devextreme/ui/notify";

//type MyEnum = 'up' | 'down' | 'left' | 'right'
//https://stackoverflow.com/questions/49746638/how-to-use-enum-as-props-in-react-typescript

export const ReportTemplateModelNames = {
    Sql: "sql",
    Filter: "filter",
    Component: "component",
    Report: "report",
    Layout: "layout",

} as const;

type ReportTemplateModelNames = typeof ReportTemplateModelNames[keyof typeof ReportTemplateModelNames]

export interface IReportTemplateModelProps {
    modelName: ReportTemplateModelNames;
}


const ReportTemplateModel: React.FC<PropsWithChildren<IReportTemplateModelProps>> = ({ modelName, ...props }) => {
    const authStore = useAuthStore();
    const navigate = useNavigate();

    let messageValidateJson = "Структура - НЕ валидный JSON";

    const getMessageValidateJson = () => {
        return messageValidateJson;
    }

    const licenceStore = LicenceDataSource.licenceStore(
        {
            url: "/api/main/" + modelName.toString(),
            authStore: authStore,
            cacheDuration: 0,
        }
    );

    const getStore = (modelName, loadMode) => {
        return LicenceDataSource.licenceDataSource(
//        return LicenceDataSource.licenceStore(
            {
                url: "/api/main/" + modelName,
                authStore: authStore,
                cacheDuration: 0,
                loadMode: loadMode,
                groupName: "GroupName",
            });
    }

    const titlePopup = () => {
        if (modelName == ReportTemplateModelNames.Sql) {
            return "Карточка SQL-запроса";
        }
        else if (modelName == ReportTemplateModelNames.Component) {
            return "Карточка компонента";
        }
        else if (modelName == ReportTemplateModelNames.Filter) {
            return "Карточка фильтра";
        }
        else if (modelName == ReportTemplateModelNames.Report) {
            return "Карточка отчета";
        }
        else if (modelName == ReportTemplateModelNames.Layout) {
            return "Карточка макета";
        }
        else
            return "Карточка " + modelName;
    }
    const popupOptions = {
        title: titlePopup(),
        showTitle: true,
        height: 600,
        width: 1200,
    };

    const isCloneIconVisible = (e) => {
        return !e.row.isEditing;
    }

    const isCloneIconDisabled = (e) => {
        return false;
    }

    const cloneIconClick = async (e) => {
        let key = e.row.data.Id;
        try {
            const newId = new Guid().toString();
            const clonedItem = { ...e.row.data, Id: newId, Name: 'Копия ' + e.row.data.Name };
            await licenceStore.insert(
                clonedItem
            );
            key = newId;
        }
        catch (e) {
            console.log(e);
        }
        e.component.refresh();
        e.component.navigateToRow(key);
    }

    function validateJson(json) {
        let errorMessage = "";
        try {
            let jsonData = JSON.stringify(JSON.parse(json), null, 2);
        } catch (e) {
            errorMessage = e.message;
        }
        return errorMessage;
    }

    const validateColumnsJson = (e) => {
        let errorMessage = validateJson(e.value);
        let result = errorMessage == "";
        if (!result) {
            messageValidateJson = errorMessage;
        }
        return result;
    }

    const getGroupNamesStore = () => {
        return LicenceDataSource.licenceStore(
            {
                url: "api/reports/getGroupNames/" + modelName,
                authStore: authStore,
                cacheDuration: 0,
                keyName: "GroupName",
                byKeyInSearch: true,
            });
    }
    const customItemCreating = (e) => {
        if (!e.customItem) {
            e.customItem = { GroupName: e.text };
        }
    }
    const onRunButtonClick = (e) => {
        if (e && e.row && e.row.data) {
            if (authStore.storage["useTabPanel"]) {
                authStore.storage["addTabForReportView"](e.row.data.Name, e.row.data.Id);
            }
            else {
                navigate(`/reports/${e.row.data.Id}`, { replace: true });
            }
        }
    }
    const onDownLoadButtonClick = async (e) => {
        await downLoadByUrl(`report_${e.row.data.Id}.json`,
            {
                url: `api/reports/download/${e.row.data.Id}`,
                authStore: authStore,
                cacheDuration: 0,
            }
        );
    }

    const getLookupEditorOptions = (modelName) => {
        return {
            //            allowClearing: true,
            showClearButton: true,
            searchEnabled: true,
            showSelectionControls: false,
            dataSource: getStore(modelName, "raw"),
            displayExpr: LicenceFormat.selectBoxDisplayExprOnlyName,
            valueExpr: "Id",
            grouped: true,
        };
    }

    const onDownLoadAllButtonClick = async (e) => {
        await downLoadByUrl(`reports_all.json`,
            {
                url: `api/reports/downloadAll`,
                authStore: authStore,
                cacheDuration: 0,
            }
        );
    }

    const onDownLoadAllAsArchiveButtonClick = async (e) => {
        await downLoadBlobByUrl(
            {
                url: `api/reports/DownLoadAllAsArchive`,
                authStore: authStore,
                cacheDuration: 0,
            }
        );
    }

    const renderItemFileUploader = () => {
        return <FileUploader
            className="file-uploader"
            selectButtonText="Обновить отчеты"
            labelText=""
            uploadMode="useForm" />;
    }

    const uploadZipFile = async (ev) => {
        let input = document.createElement('input');
        input.type = "file";
        input.accept = ".zip";

        const uploadFiles = async (file) => {
            console.log("Uploading file...");
            const formData = new FormData();
            formData.append("file", file, file.name);
            let res = await UpLoadByUrl(formData,
                {
                    url: `api/reports/UpLoadArch`,
                    authStore: authStore,
                    cacheDuration: 0,
                    headers: {
                        //'Content-Type': 'multipart/form-data'
                        'Content-Type': undefined
                    },
                }
            );
            //ev.component.refresh();
            return res;

        };

        input.addEventListener("change", async event => {
            const file = event.target["files"][0];
            try {
                let res = await uploadFiles(file);
                console.log(res);
                const okCount = res?.data?.OkCount || 0;
                notify(`Обновлено ${okCount} отчетов!`);
            }
            catch (err) {
                console.log(err);
                notify(err.message, "error");
            }
        });
        input.click();
        
    }

    const onUploadButtonClick = async (ev) => {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = ".json";

        input.onchange = e => {

            // getting a hold of the file reference
            let file = e.target["files"][0];

            // setting up the reader
            let reader = new FileReader();
            reader.readAsText(file, 'UTF-8');

            // here we tell the reader what to do when it's done reading...
            reader.onload = async readerEvent => {
                let content = readerEvent.target.result; // this is the content!
                console.log(content);
                try {
                    let res = await UpLoadByUrl(content,
                        {
                            url: `api/reports/upload`,
                            authStore: authStore,
                            cacheDuration: 0,
                        }
                    );
                    //ev.component.refresh();
                    const okCount = res?.data?.OkCount || 0;
                    notify(`Обновлено ${okCount} отчетов!`);
                }
                catch (err) {
                    console.log(err);
                    notify(err.message, "error");
                }
            }
        }
        input.click();
    }
    const onUploadFromArchButtonClick = async (ev) => {
        await uploadZipFile(ev);
    }

    const onExportAllReportsToUserRightsButtonClick = async (e) => {
        const response = await getSmartFetchData(
            {
                authStore: authStore,
                url: `api/reports/exportAllReportsToUserRights`,
                config: {},
            }
        );
    }    

    return (
        <CommonLicenceDataGrid
            licenceStore={licenceStore}
            columnAutoWidth={false}
            allowColumnReordering={isMobileDevice ? false : true}
            toolbar={{
                items: [
                    {
                        location: "after",
                        visible: modelName == ReportTemplateModelNames.Report,
                        widget: "dxButton",
                        options: {
                            text: 'Отчеты -> в права доступа',
                            onClick: onExportAllReportsToUserRightsButtonClick
                        }
                    },
                    {
                        location:"after",
                        visible: modelName == ReportTemplateModelNames.Report,
                        widget: "dxButton",
                        options: {
                            text: 'Выгрузить все отчеты в json',
                            onClick:onDownLoadAllButtonClick
                        }
                    },
                    {
                        location: "after",
                        visible: modelName == ReportTemplateModelNames.Report,
                        widget: "dxButton",
                        options: {
                            text: 'Выгрузить все отчеты в zip',
                            onClick: onDownLoadAllAsArchiveButtonClick
                        }
                    },
                    {
                        location: "after",
                        visible: modelName == ReportTemplateModelNames.Report,
//                        template: renderItemFileUploader,
                        widget: "dxButton",
                        options: {
                            text: 'Обновить отчеты из json',
                            onClick: onUploadButtonClick
//                            onClick: onDownLoadAllButtonClick
                        }
                    },
                    {
                        location: "after",
                        visible: modelName == ReportTemplateModelNames.Report,
                        widget: "dxButton",
                        options: {
                            text: 'Обновить отчеты из zip',
                            onClick: onUploadFromArchButtonClick
                        }
                    },
                    {
                        name: "addRowButton",
                        showText: "inMenu"
                    }
                ]
            }}
            summary={{
                totalItems: [
                    { column: "Name", summaryType: "count", displayFormat: "Записей: {0}", valueFormat: "#" }
                    ],
                groupItems: [
                    { column: "Name", summaryType: "count", displayFormat: "Записей: {0}", valueFormat: "#" }
                ]
                    }}
            defaultColumns={[
                {
                    dataField: "GroupName", caption: "Группа",
                    visible: true, width: "30%", groupIndex: 0,
//                    sortOrder: "asc", sortIndex: 0,
                },
                {
                    type: "buttons", caption: "Управление", visible: true,
                    buttons: [
                        { name: "edit" },
                        { name: "delete" },
                        {
                            hint: "Clone", icon: "copy",
                            visible: isCloneIconVisible, disabled: isCloneIconDisabled,
                            onClick: cloneIconClick,
                        },
                        {
                            hint: "Построить отчет", icon: "video",
                            visible: modelName == ReportTemplateModelNames.Report,
                            onClick: onRunButtonClick,
                        },
                        {
                            hint: "Скачать отчет", icon: "download",
                            visible: modelName == ReportTemplateModelNames.Report,
                            onClick: onDownLoadButtonClick,
                        },

                    ],
                },
                {
                    dataField: "Name", caption: "Наименование", visible: true, width: "70%",
                    validationRule: { type: "required" },
                    sortOrder: "asc", sortIndex: 0,
                },
                {
                    dataField: "Code", caption: "Код",
                    visible: modelName == ReportTemplateModelNames.Sql,
                    width: "30%",
//                    validationRule: {type: "required"}
                },
                {
                    dataField: "Id", caption: "ID", hidingPriority: 0,
                    visible: modelName == ReportTemplateModelNames.Report,
                    width: "30%",
                },
                { dataField: "Sql", caption: "SQL-запрос", visible: false, },
                { dataField: "JsonObject", caption: "JSON-структура", visible: false, },
                { dataField: "Layout", caption: "Макет отчета", visible: false, },
                {
                    dataField: "FilterId", caption: "Структура фильтра", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Filter),
                },
                {
                    dataField: "LayoutId", caption: "Макет отчета", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Layout),
                },
                {
                    dataField: "MainComponentId", caption: "Структура тела отчета", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Component),
                },
                {
                    dataField: "MainSqlId", caption: "SQL-запрос для получения данных", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "HeaderComponentId", caption: "Структура заголовка отчета", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Component),
                },
                {
                    dataField: "HeaderSqlId", caption: "SQL-запрос для получения данных для заголовка", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "FooterComponentId", caption: "Структура подвала отчета", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Component),
                },
                {
                    dataField: "FooterSqlId", caption: "SQL-запрос для получения данных для подвала", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql1Id", caption: "Доп. SQL-запрос 1", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql2Id", caption: "Доп. SQL-запрос 2", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql3Id", caption: "Доп. SQL-запрос 3", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql4Id", caption: "Доп. SQL-запрос 4", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql5Id", caption: "Доп. SQL-запрос 5", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql6Id", caption: "Доп. SQL-запрос 6", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
                {
                    dataField: "Sql7Id", caption: "Доп. SQL-запрос 7", visible: false,
                    editorType: "dxSelectBox",
                    editorOptions: getLookupEditorOptions(ReportTemplateModelNames.Sql),
                },
            ]}
        >
            <Editing
                mode="popup"
                allowAdding={true}
                allowUpdating={true}
                allowDeleting={true}
                popup={popupOptions}
                useIcons={true}
            >
                <Form
                    labelMode="static"
                    colCount={1}
                    showValidationSummary={true}
                    validationGroup="customData"
                >
                    <GroupItem colCount={5}>
                        <GroupItem colSpan={1}
                            visible={modelName == ReportTemplateModelNames.Sql}
                        >
                            <SimpleItem dataField="Code"/>
                        </GroupItem>
                        <GroupItem colSpan={2}>
                            <SimpleItem dataField="Name" />
                        </GroupItem>
                        <GroupItem colSpan={2}>
                            <SimpleItem
                                dataField="GroupName"
                                editorType="dxSelectBox"
                                editorOptions={{
                                    dataSource: getGroupNamesStore(),
                                    showClearButton: true,
                                    displayExpr: "GroupName",
                                    valueExpr: "GroupName",
                                    acceptCustomValue: true,
                                    onCustomItemCreating: customItemCreating,
                                    defaultValue: ""
                                }}
                            >
                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>

                    <SimpleItem
                        dataField="FilterId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="LayoutId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />

                    <SimpleItem
                        dataField="MainComponentId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="MainSqlId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="HeaderComponentId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="HeaderSqlId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="FooterComponentId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="FooterSqlId"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />

                    <SimpleItem
                        dataField="Sql1Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql2Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql3Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql4Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql5Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql6Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />
                    <SimpleItem
                        dataField="Sql7Id"
                        visible={modelName == ReportTemplateModelNames.Report}
                    />


                    <SimpleItem
                        visible={modelName == ReportTemplateModelNames.Layout}
                        dataField="Layout"
                        editorType="dxTextArea"
                        editorOptions={{
                            height: "350px",
                            autoResizeEnabled: false
                        }}
                        validationRules={[
                            {
                                type: "required",
                                message: "Макет отчета должен быть не пустой"
                            }
                        ]
                        }
                    >
                        <Label
                            location="top"
                            alignment="center" />
                    </SimpleItem>

                    <SimpleItem
                        visible={modelName == ReportTemplateModelNames.Sql}
                        dataField="Sql"
                        editorType="dxTextArea"
                        editorOptions={{
                            height: "350px",
                            autoResizeEnabled: false
                        }}
                        validationRules={[
                            {
                                type: "required",
                                message: "SQL-запрос должен быть не пустой"
                            }
                        ]
                        }
                    >
                        <Label
                            location="top"
                            alignment="center" />
                    </SimpleItem>
                    <SimpleItem
                        visible={modelName == ReportTemplateModelNames.Component || modelName == ReportTemplateModelNames.Filter}
                        dataField="JsonObject"
                        editorType="dxTextArea"
                        editorOptions={{
                            height: "350px",
                            autoResizeEnabled: false
                        }}
                        validationRules={[
                            {
                                type: "required",
                                message: "Структура - Должен быть валидный JSON"
                            },
                            {
                                type: "custom",
                                message: getMessageValidateJson(),
                                validationCallback: validateColumnsJson
                            },
                        ]
                        }
                    >
                        <Label
                            location="top"
                            alignment="center" />
                    </SimpleItem>
                </Form>
            </Editing>
            <GroupPanel
                visible={true}
                allowColumnDragging={isMobileDevice ? false : true}
            />
            {false && <Toolbar
                visible={true}
            >
                <Item
                    location="after"
                    visible={modelName == ReportTemplateModelNames.Report}
                >
                    <Button
                        text='Выгрузить все отчеты'
                        onClick={onDownLoadAllButtonClick} />
                </Item>
                <Item
                    location="after"
                    visible={modelName == ReportTemplateModelNames.Report}
                >
                    <FileUploader
                        className="file-uploader"
                        selectButtonText="Обновить отчеты"
                        labelText=""
                        uploadMode="useForm" />
                </Item>
                <Item name="addRowButton"
                    showText="inMenu"
                />
            </Toolbar>
            }

        </CommonLicenceDataGrid>
    );
}


export default React.memo(ReportTemplateModel);
